import { Box, Checkbox, CheckboxGroup, Heading, Image, Stack, Text } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MainModel from "../../../../components/Models/main-model";
import {
  createExamQuestionsRequest,
  getAllExamQuestionsRequest,
} from "../../../../modules/admin-modules/exams/Actions";
import { closeQuestionsListModel } from "../../../../modules/admin-modules/models/Actions";

function questionContainerIds(chapters, explicitIds) {
  if (Array.isArray(explicitIds) && explicitIds.length > 0) {
    return [...new Set(explicitIds.filter((id) => id != null && id !== ""))];
  }
  const list = Array.isArray(chapters)
    ? chapters
    : chapters && typeof chapters === "object"
      ? Object.values(chapters)
      : [];
  return [
    ...new Set(
      list
        .filter(Boolean)
        .slice(1)
        .map((ch) => ch?.chapter_id ?? ch?.id)
        .filter((id) => id != null && id !== "")
    ),
  ];
}

const QUESTION_IMAGE_BASE = "https://edutopiaonline.com/api";

function questionImageSrc(image) {
  const value = String(image ?? "").trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return `${QUESTION_IMAGE_BASE}/${value.replace(/^\/+/, "")}`;
}

function chapterLabel(question) {
  return question?.chapter?.name || question?.chapter?.name_ar || "Chapter";
}

function groupQuestionsByChapter(questions) {
  const groups = [];
  const indexByChapter = new Map();
  (questions || []).forEach((question) => {
    const chapterId = question?.chapter?.id ?? "none";
    if (!indexByChapter.has(chapterId)) {
      indexByChapter.set(chapterId, groups.length);
      groups.push({
        id: chapterId,
        name: chapterLabel(question),
        questions: [],
      });
    }
    groups[indexByChapter.get(chapterId)].questions.push(question);
  });
  return groups;
}

const Questions = ({ examData, selectedData, isAdd }) => {
  const [values, setValues] = useState([]);

  const dispatch = useDispatch();
  const data = isAdd
    ? examData
    : {
        exam: selectedData?.id,
        question_number: selectedData?.question_number,
      };
  const chapterIds = useMemo(
    () =>
      questionContainerIds(
        isAdd ? examData?.chapters : selectedData?.chapters,
        isAdd ? examData?.chapter_ids : undefined
      ),
    [isAdd, examData, selectedData]
  );
  const questionsBank = useSelector((state) => state.exams.examQuestions);
  const isLoading = useSelector((state) => state.exams.isLoading);
  const openModel = useSelector((state) => state.model.isOpen26);
  const questionGroups = useMemo(
    () => groupQuestionsByChapter(questionsBank),
    [questionsBank]
  );

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        اختر الاسئلة
      </Heading>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeQuestionsListModel());
  };

  useEffect(() => {
    if (!openModel || chapterIds.length === 0) return;
    chapterIds.forEach((id) => dispatch(getAllExamQuestionsRequest(id)));
  }, [openModel, chapterIds, dispatch]);

  useEffect(() => {
    if (values?.length > data?.question_number)
      toast.error(`you should choose ${data?.question_number} Questions only`);
  }, [values]);
  const handelSave = async () => {
    if (values?.length <= data?.question_number) {
      let formData = new FormData();
      formData.append("exam_id", data?.exam);
      formData.append("count", data?.question_number);

      await values?.map((val, index) => {
        formData.append(`questions[${index}]`, val);
      });
      const action = () => {
        dispatch(closeQuestionsListModel());
      };
      dispatch(createExamQuestionsRequest(formData, action));
    } else {
      toast.error(`you should choose ${data?.question_number} Questions only`);
    }
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openModel}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handelSave}
    >
      <CheckboxGroup colorScheme="green" onChange={(e) => setValues(e)}>
        <Stack spacing={6} direction="column">
          {questionGroups.map((group) => (
            <Box key={group.id}>
              <Text
                fontWeight="800"
                fontSize="sm"
                color="var(--text-primary)"
                bg="var(--surface-muted)"
                px={3}
                py={2}
                mb={3}
                borderRadius="md"
              >
                {group.name}
              </Text>
              <Stack spacing={4}>
                {group.questions.map((question) => {
                  const imageSrc = questionImageSrc(question?.image);
                  return (
                    <Checkbox
                      key={question?.id}
                      value={question?.id?.toString()}
                      alignItems="flex-start"
                      w="100%"
                      sx={{
                        ".chakra-checkbox__control": { mt: "4px" },
                        ".chakra-checkbox__label": { width: "100%" },
                      }}
                    >
                      <Box>
                        {question?.question ? (
                          <Box
                            fontSize="sm"
                            color="var(--text-primary)"
                            sx={{
                              "& p": { margin: 0 },
                              "& p, & span, & div, & li": { color: "inherit" },
                            }}
                            dangerouslySetInnerHTML={{ __html: question.question }}
                          />
                        ) : null}
                        {imageSrc ? (
                          <Image
                            src={imageSrc}
                            alt="Question"
                            maxW="100%"
                            maxH="220px"
                            objectFit="contain"
                            borderRadius="md"
                            borderWidth="1px"
                            borderColor="var(--border-subtle)"
                            mt={2}
                            bg="white"
                          />
                        ) : null}
                      </Box>
                    </Checkbox>
                  );
                })}
              </Stack>
            </Box>
          ))}
        </Stack>
      </CheckboxGroup>
    </MainModel>
  );
};

export default Questions;
